import ReactIcon from "../../assets/TechStack/react-js-icon.svg";
import ReduxIcon from "../../assets/TechStack/redux-icon.svg";
import NextjsIcon from "../../assets/TechStack/nextjs-icon.svg";
import ViewIcon from "../../assets/TechStack/vue-js-icon.svg";
import AngularIcon from "../../assets/TechStack/angular-icon.svg";
import NodejsIcon from "../../assets/TechStack/node-js-icon.svg";
import MongoDBIcon from "../../assets/TechStack/mongodb-icon.svg";
import MySQLIcon from "../../assets/TechStack/mysql-icon.svg";
import GraphQlIcon from "../../assets/TechStack/graphql-icon.svg";
import PhpIcon from "../../assets/TechStack/php.svg";
import LaravelIcon from "../../assets/TechStack/laravel-icon.svg";
import FlutterIcon from "../../assets/TechStack/Flutter.png";
import SwiftIcon from "../../assets/TechStack/swift.svg";
import PhotoShopIcon from "../../assets/TechStack/adobe-photoshop-icon.svg";
import FigmaIcon from "../../assets/TechStack/figma.svg";
import IllustratorIcon from "../../assets/TechStack/adobe-illustrator-icon.svg";
import InDesignIcon from "../../assets/TechStack/indesign-icon.svg";
import CorelDrawIcon from "../../assets/TechStack/coreldraw.svg";
import XDIcon from "../../assets/TechStack/adobe-xd-icon.svg";
import AWSIcon from "../../assets/TechStack/aws-icon.svg";
import GoogleCloudIcon from "../../assets/TechStack/google-cloud-icon.svg";
import AZUREIcon from "../../assets/TechStack/azure-icon.svg";
import { motion } from "framer-motion";



const techStack = [
  {
    id: 1,
    title: "Design & Development",
    technologyList: [
      {
        id: 1,
        techName: "REACT JS",
        icon: ReactIcon,
      },
      {
        id: 2,
        techName: "R Native",
        icon: ReactIcon,
      },
      {
        id: 3,
        techName: "Redux",
        icon: ReduxIcon,
      },
      {
        id: 4,
        techName: "Next Js",
        icon: NextjsIcon,
      },
      {
        id: 5,
        techName: "Vue Js",
        icon: ViewIcon,
      },
      {
        id: 6,
        techName: "Angular",
        icon: AngularIcon,
      },
      {
        id: 7,
        techName: "Node Js",
        icon: NodejsIcon,
      },
      {
        id: 8,
        techName: "MongoDB",
        icon: MongoDBIcon,
      },
      {
        id: 9,
        techName: "My Sql",
        icon: MySQLIcon,
      },
      {
        id: 10,
        techName: "GraphQl",
        icon: GraphQlIcon,
      },
      {
        id: 11,
        techName: "Php",
        icon: PhpIcon,
      },
      {
        id: 12,
        techName: "Laravel",
        icon: LaravelIcon,
      },
      {
        id: 13,
        techName: "Flutter",
        icon: FlutterIcon,
      },
      {
        id: 14,
        techName: "Swift",
        icon: SwiftIcon,
      },
    ],
  },
  {
    id: 2,
    title: "Graphics & Prototyping",
    technologyList: [
      {
        id: 1,
        techName: "Figma",
        icon: FigmaIcon,
      },
      {
        id: 2,
        techName: "Photoshop",
        icon: PhotoShopIcon,
      },
      {
        id: 3,
        techName: "Illustrator",
        icon: IllustratorIcon,
      },
      {
        id: 4,
        techName: "InDesign",
        icon: InDesignIcon,
      },
      {
        id: 6,
        techName: "XD",
        icon: XDIcon,
      },
    ],
  },
  {
    id: 3,
    title: "Cloud & Servers",
    technologyList: [
      {
        id: 1,
        techName: "AWS",
        icon: AWSIcon,
      },
      {
        id: 2,
        techName: "GOOGLE CLOUD",
        icon: GoogleCloudIcon,
      },
      {
        id: 3,
        techName: "AZURE",
        icon: AZUREIcon,
      },
    ],
  },
];



const containerVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.5, ease: "easeOut" },
  }),
};

export default function TechStack() {
  return (
    <div className="w-full flex flex-col gap-10 my-16 px-4 sm:px-8 md:px-16 lg:px-28">
      
      {/* Header */}
      <div className="text-center mb-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl lg:text-5xl font-semibold text-primary-color/90"
        >
          Our Tech Stack
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-base text-gray-600 mt-3"
        >
          Maximizing Business Value through the Right Technology
        </motion.p>
      </div>

      {/* Categories */}
      <div className="flex flex-col gap-16">
        {techStack.map((category, idx) => (
          <motion.div
            key={category.id}
            custom={idx}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={containerVariants}
            className="flex flex-col gap-6"
          >
            {/* Category Title */}
            <p className="text-xl md:text-2xl lg:text-3xl font-semibold text-gray-800">
              {category.title}
            </p>

            {/* Tech Items */}
            <div className="
              w-full grid 
              grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 
              gap-6 md:gap-8
            ">
              {category.technologyList.map((tech) => (
                <motion.div
                  key={tech.id}
                  whileHover={{ scale: 1.07, y: -4 }}
                  transition={{ type: "spring", stiffness: 200 }}
                  className="flex flex-col items-center gap-4 cursor-pointer"
                >
                  {/* Icon Container */}
                  <div className="
                    bg-white shadow-sm border border-gray-100
                    h-20 w-20 md:h-28 md:w-28 lg:h-32 lg:w-32 
                    flex justify-center items-center rounded-3xl 
                    hover:shadow-lg transition-all duration-200
                    p-4
                  ">
                    <img
                      src={tech.icon}
                      alt={tech.techName}
                      className="h-10 md:h-14 lg:h-16 object-contain select-none"
                      draggable={false}
                    />
                  </div>

                  {/* Name */}
                  <p className="font-semibold text-xs md:text-sm lg:text-base text-gray-700 tracking-wide text-center select-none">
                    {tech.techName.toUpperCase()}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}


